import React from "react";

import ResultCard from "../resultCard";

const MostExpPlayer = ({ player }) => (
  <ResultCard label="Most expensive player" player={player} />
);

export default MostExpPlayer;
